import StandardLayout from './StandardLayout';


export default StandardLayout;
